(() => {
  const init = (root) => {
    if (!root || root.dataset.relyvReady === 'true') return;
    root.dataset.relyvReady = 'true';

    const cards = [...root.querySelectorAll('[data-variant-card]')];
    const variantInput = root.querySelector('[data-variant-input]');
    const mainPrice = root.querySelector('[data-main-price]');
    const comparePrice = root.querySelector('[data-compare-price]');
    const saveBadge = root.querySelector('[data-save-badge]');
    const savePercent = root.querySelector('[data-save-percent]');
    const buttonPrice = root.querySelector('[data-button-price]');
    const mobilePrice = root.querySelector('[data-mobile-price]');
    const addButton = root.querySelector('[data-add-button]');
    const addLabel = root.querySelector('[data-add-label]');
    const heroImage = root.querySelector('.relyv-product-image');

    const selectVariant = (card) => {
      if (!card || card.disabled) return;
      cards.forEach((item) => {
        const active = item === card;
        item.classList.toggle('relyv-active', active);
        item.setAttribute('aria-checked', active ? 'true' : 'false');
      });
      const available = card.dataset.available === 'true';
      if (variantInput) variantInput.value = card.dataset.variantId;
      if (mainPrice) mainPrice.textContent = card.dataset.price;
      if (buttonPrice) buttonPrice.textContent = card.dataset.price;
      if (mobilePrice) mobilePrice.textContent = card.dataset.price;
      if (comparePrice) {
        comparePrice.textContent = card.dataset.comparePrice || '';
        comparePrice.hidden = card.dataset.hasCompare !== 'true';
      }
      const saving = Number(card.dataset.savePercent || 0);
      if (saveBadge) saveBadge.hidden = saving <= 0;
      if (savePercent) savePercent.textContent = String(saving);
      if (addButton) addButton.disabled = !available;
      if (addLabel) addLabel.textContent = available ? (addButton?.dataset.defaultLabel || 'Add to cart') : 'Sold out';
      if (heroImage && card.dataset.imageUrl) { heroImage.src = card.dataset.imageUrl; heroImage.removeAttribute('srcset'); }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', card.dataset.variantId);
      window.history.replaceState({}, '', url);
    };

    cards.forEach((card) => card.addEventListener('click', () => selectVariant(card)));

    root.querySelectorAll('.relyv-faq-q').forEach((button) => {
      button.addEventListener('click', () => {
        const item = button.closest('.relyv-faq-item');
        const open = item.classList.toggle('relyv-open');
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    root.querySelector('[data-mobile-buy]')?.addEventListener('click', () => {
      root.querySelector('.relyv-product-card')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  };

  const boot = () => document.querySelectorAll('.relyv-landing').forEach(init);
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('.relyv-landing')));
})();
